import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import './vocabulary-button.scss';

/**
 * Іконка «Слова з озвучкою» (навушники) — веде на `/vocabulary`; токен уроку передається
 * в стані переходу, щоб не світився в адресі.
 *
 * Стоїть одразу після іконки словника (PDF) скрізь, де є `vocabulary_token`.
 * Іконки в спрайті немає, тому SVG інлайновий; класи ті самі, що в ButtonIcon,
 * щоб виглядала як сусідні кнопки матеріалів.
 */
const NO_FILL = { fill: 'none' };

/** Навушники контуром; кольори — через клас `icon--*`, як у решти іконок. */
export const HeadphonesIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* Глобальний стиль кабінету заливає будь-який path кольором (svg path fill) — тут потрібен лише контур */}
    <path d="M4.5 14v-2.5a7.5 7.5 0 0 1 15 0V14" style={NO_FILL} />
    <rect x="4.5" y="13" width="4" height="6" rx="1.6" style={NO_FILL} />
    <rect x="15.5" y="13" width="4" height="6" rx="1.6" style={NO_FILL} />
  </svg>
);

HeadphonesIcon.propTypes = { className: PropTypes.string };
HeadphonesIcon.defaultProps = { className: 'icon icon--md icon--green' };

const VocabularyButton = ({ token, classes, title }) => {
  const navigate = useNavigate();

  if (!token) return null;

  return (
    <button
      type="button"
      // Фіолетова пульсація і підстрибування — щоб учні помітили нову кнопку
      className={`btn-icon btn-icon--white btn-icon--lg vocabulary-btn ${classes}`.trim()}
      title={title}
      aria-label={title}
      onClick={() => navigate('/vocabulary', { state: { w: token } })}
    >
      <HeadphonesIcon className="icon icon--md icon--violet" />
    </button>
  );
};

VocabularyButton.propTypes = {
  token: PropTypes.string,
  classes: PropTypes.string,
  title: PropTypes.string,
};

VocabularyButton.defaultProps = {
  token: null,
  classes: '',
  title: 'Слова з озвучкою',
};

export default VocabularyButton;
